<template>
  <div>
    <div class="d-flex">
      <v-btn
        large
        class="mt-1 mr-4"
        icon
        @click="$router.push({ name: 'dashboard' })"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="mb-8">{{ client.prenom + " " + client.nom }}</h1>
      <v-btn
        large
        class="mt-1 ml-4 orange"
        color="white"
        icon
        @click="editClient"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-spacer></v-spacer>

      <BoutonEditReport :report="client.report ? client.report : 0" />
      <v-btn
        v-if="!client.eligible"
        color="green"
        dark
        class="mt-2 ml-2"
        rounded
        @click="ouvrirCreate"
      >
        <v-icon class="mb-1" size="19">mdi-plus</v-icon>Paiement
      </v-btn>
    </div>
    <div v-if="error != ''">{{ error }}</div>
    <div v-if="!loading">
      <v-row>
        <v-col cols="12" sm="7">
          <div
            class="mb-4"
            style="font-weight: bold; font-size: 1.1rem"
            v-if="client.superClient"
          >
            <v-icon class="orange--text mr-2">mdi-alert</v-icon>Ce client a une
            remise de 10% à chaque passage !
          </div>
          <AdresseClient :client="client" />
        </v-col>
        <v-col cols="12" sm="5">
          <CarteEligibilite
            :report="client.report"
            :eligible="client.eligible"
            :montant="sommeAccumulee"
          />
        </v-col>
      </v-row>
      <h2 class="my-5">Carte en cours</h2>
      <CarteDeFidelite @edit-paiement="ouvrirEdit" :paiements="derniereCarte" />

      <div
        class="rounded-xl mt-8 pa-5 blue lighten-5"
        v-if="client.commentaire"
      >
        <div><strong>Commentaire</strong></div>
        {{ client.commentaire }}
      </div>
      <v-divider class="my-8"></v-divider>
      <h2 class="mb-7" v-if="cartes.length > 0">Anciennes cartes</h2>
      <div v-for="carte in cartes" :key="carte[0].id">
        <CarteDeFidelite
          @edit-paiement="ouvrirEdit"
          class="mb-10"
          :paiements="carte"
        />
      </div>
    </div>
    <FicheSkeletonLoader v-else />
    <PaiementDialog
      :mode="mode"
      :paiement="selectedPaiement"
      @fermer="showPaiementDialog = false"
      @add-paiement="addPaiement"
      @edit-paiement="editPaiement"
      @delete-paiement="deletePaiement"
      v-if="showPaiementDialog"
    />
  </div>
</template>

<script>
import { db } from "@/firebase";
import CarteEligibilite from "../components/CarteEligibilite";
import AdresseClient from "../components/AdresseClient";
import moment from "moment/src/moment";
import FicheSkeletonLoader from "../components/FicheSkeletonLoader";
import CarteDeFidelite from "../components/CarteDeFidelite";
import PaiementDialog from "../components/PaiementDialog";
import BoutonEditReport from "../components/BoutonEditReport";

export default {
  components: {
    CarteEligibilite,
    AdresseClient,
    FicheSkeletonLoader,
    CarteDeFidelite,
    PaiementDialog,
    BoutonEditReport,
  },

  data: () => ({
    paiements: [],
    selectedPaiement: {},
    mode: "create",
    loading: false,
    error: "",
    cartes: [],
    derniereCarte: [],
    showPaiementDialog: false,
  }),

  mounted() {
    this.getPaiements();
  },

  computed: {
    sommeAccumulee() {
      let total = 0;
      const sommeReportee = this.client.report || 0;
      if (this.paiements.length == 0) return 0;
      if (this.client.eligible && this.derniereCarte.length == 0) {
        this.cartes[0].forEach((paiement) => {
          total += paiement.montant;
        });
      } else {
        this.derniereCarte.forEach((paiement) => {
          total += paiement.montant;
        });
      }

      return Math.round(0.1 * total + sommeReportee) / 100;
    },
    client() {
      const id = this.$route.params.id;
      return this.$store.state.clients.filter((c) => c.id == id)[0];
    },
    paiementsRendered() {
      return this.paiements.map((p) => {
        p.dateRendered = moment(p.date.toDate()).format("DD/MM/YYYY");
        return p;
      });
    },
  },

  methods: {
    editClient() {
      const id = this.$route.params.id;
      this.$router.push({
        name: "editClient",
        params: { id: id, provenance: "fiche" },
      });
    },
    ouvrirCreate() {
      this.mode = "create";
      this.showPaiementDialog = true;
    },
    ouvrirEdit(paiement) {
      this.selectedPaiement = paiement;
      this.mode = "edit";
      this.showPaiementDialog = true;
    },
    editPaiement(newPaiement) {
      const oldPaiement = this.paiements.filter(
        (p) => p.id == newPaiement.id
      )[0];
      const index = this.paiements.indexOf(oldPaiement);
      this.paiements.splice(index, 1, newPaiement);
      this.separatePaiements();
    },
    deletePaiement(id) {
      this.paiements = this.paiements.filter((p) => p.id != id);
      this.separatePaiements();
    },
    async addPaiement(paiement) {
      if (this.derniereCarte.length == 9) {
        await db.doc("clients/" + this.$route.params.id).update({
          eligible: true,
        });
      }
      this.paiements.push(paiement);
      this.separatePaiements();
    },
    separatePaiements() {
      this.cartes = [];
      const tailleCarte = 10;
      let paiementsLeft = [...this.paiementsRendered];
      while (paiementsLeft.length >= tailleCarte) {
        const l = paiementsLeft.length;
        const carte = paiementsLeft.slice(0, tailleCarte);
        this.cartes.push(carte);
        paiementsLeft = paiementsLeft.splice(tailleCarte, l);
      }
      this.derniereCarte = paiementsLeft;
      this.cartes = this.cartes.reverse();
    },
    async getPaiements() {
      this.loading = true;
      this.error = "";

      try {
        const id = this.$route.params.id;
        const snapPaiements = await db
          .collection("paiements")
          .where("clientId", "==", id)
          .orderBy("date", "asc")
          .get();
        snapPaiements.forEach((doc) => {
          let docData = doc.data();
          docData.id = doc.id;
          this.paiements.push(docData);
        });
        this.loading = false;
        this.separatePaiements();
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.error = "Une erreur s'est produite.";
      }
    },
  },
};
</script>

